<app-processing [visible]="!dialogVars.isReady"></app-processing>

<p-button label="New Order" [raised]="true" iconPos="right" (onClick)="openNewOrderDialog()"></p-button>

<p-dialog
  [modal]="true"
  [showHeader]="true"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="visible"
  appendTo="body"
  [style]="{ 'width': '35rem' }"
  styleClass="order-item-dialog">
  <ng-template #header>
    <h4>Create New Order</h4>
  </ng-template>
  <div class="grid">
    <div class="col-12">
      <div class="mt-1">
        <p-floatlabel variant="on" class="w-full">
          <p-select
            [options]="sites"
            [(ngModel)]="dialogVars.site"
            data-testid="site"
            filterPlaceholder="Search Unit"
            (onChange)="onSiteSelect()"
            class="w-full required"
            appendTo="body">
          </p-select>
          <label for="site">Site</label>
        </p-floatlabel>
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <div class="mt-1">
        <p-floatlabel variant="on" class="w-full">
          <p-treeselect
            inputId="locationId"
            [options]="locationNodes"
            [(ngModel)]="dialogVars.location"
            data-testid="locationId"
            filterPlaceholder="Search Unit"
            [disabled]="!locationEnabled"
            class="w-full required"
            containerStyleClass="w-full"
            appendTo="body">
          </p-treeselect>
          <label for="locationId">Location Id</label>
        </p-floatlabel>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button
        label="Cancel"
        icon="fa fa-times"
        severity="danger"
        size="small"
        [raised]="true"
        data-testid="cancelNewOrder"
        (click)="cancelNewOrder()" />
      <p-button
        label="Create New Order"
        icon="fa fa-check"
        severity="success"
        size="small"
        [raised]="true"
        data-testid="createNewOrder"
        (click)="createNewOrder()" />
    </div>
  </ng-template>
</p-dialog>
